export const PRESCREENING_STATUS = {
    APPROVED : "APPROVED",
    INACTIVE : "INACTIVE",
}